
  import createMeisterIcons from '../src/createMeisterIcons';

  const Board = createMeisterIcons("board", [["path",{"fill":"currentColor","d":"M7 4.25A3.26 3.26 0 0 0 3.75 7.5v6c0 1.798 1.376 3.25 3.25 3.25h10a3.26 3.26 0 0 0 3.25-3.25v-6A3.26 3.26 0 0 0 17 4.25zm9.901 14H17a4.76 4.76 0 0 0 4.75-4.75v-6A4.76 4.76 0 0 0 17 2.75H7A4.76 4.76 0 0 0 2.25 7.5v6c0 2.602 2.024 4.75 4.75 4.75h.099l-1.223 1.834a.75.75 0 0 0 1.248.832l1.777-2.666H15.1l1.777 2.666a.75.75 0 0 0 1.248-.832z","key":"af035b5a161bd2c127de8c8b6c0b59574743daf8","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Board
  